//Paintings.js
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import { useNavigate, useParams } from 'react-router-dom';
import Paintingcard from '../components/Paintings/Paintingcard';
import React, { useState, useEffect } from 'react';
import { getMethod } from '../services/apiService';
import { IMG_URL } from '../utility/config';
import LoadingSpinner from '../utility/LoadingSpinner';
function Paintings() {
  const [paintingData, setPaintingData] = useState([]);
  const [loading, setLoading] = useState(true);
  const IMG_BASE_URL = IMG_URL
  useEffect(() => {
    fetchData();
  }, []);
  const navigate = useNavigate();
  //Display Paintings - GET
  const fetchData = async () => {
    const response = await getMethod('paintings-all');
    console.log("res====",response)
    if (response.status && Array.isArray(response.data)) {
      var data = response.data.map(item => ({
        id: item.id,
        title: item.title,
        grid_serial_number: item.grid_serial_number,
        image_url: item.image_url ? `${IMG_BASE_URL}/${item.image_url}` : '',
      }));
      data = data.sort((a, b) => Number(a.grid_serial_number) - Number(b.grid_serial_number))
      console.log(data)
      setPaintingData(data);
      setLoading(false)
    } else {
      console.error("Error fetching paintings", response);
      setPaintingData([]);
    }
  };


  const handleClick = () => {
    navigate(`/`);  // Navigate with query param & path, query, key=value pair
  };

  if (loading) return <LoadingSpinner />;

  return (
    <div className="page-container landscape_painting">
      <h2 className="poems__title_painting"><span><a href="#" onClick={(e) => handleClick()}><img src={require('../assets/images/back.png')} style={{ width: 25 }} /></a></span>Paintings</h2>
      <div className="painting-list">
        {Array.isArray(paintingData) &&
          paintingData.map(paintings => (
            <Paintingcard
              key={paintings.id}
              image_url={paintings.image_url}
              title={paintings.title}
              id={paintings.id} />
          ))}
      </div>

      {/* <button className='poem-card__button'>
        <Link to={`/buyerszone`}>Buyer's Zone</Link>
      </button> */}
    </div>
  );
}
export default Paintings;